import { FinancialAccountSubType } from '/@/modules/financialaccount/constants/FinancialAccountSubType';
import { FinancialAccountTfsaType } from '/@/modules/financialaccount/constants/FinancialAccountTfsaType';
import { FinancialAccountRrifType } from '/@/modules/financialaccount/constants/FinancialAccountRrifType';

export class FinancialAccountSubTypeOptionsMeta {
  static factory(subType) {
    switch (subType) {
      case FinancialAccountSubType.INVESTMENT_RRIF.key:
        return FinancialAccountRrifType;
      case FinancialAccountSubType.INVESTMENT_TFSA.key:
        return FinancialAccountTfsaType;
      default:
        return null;
    }
  }
}
